import React, { useState, useEffect } from 'react';
import './AtributosInfo.css';
import baseURL from '../../url';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

export default function AtributosInfo() {
    const [items, setItems] = useState([]);
    const [conjuntos, setConjuntos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editando, setEditando] = useState(null);

    // Form fields
    const [nombre, setNombre] = useState('');
    const [idAtributo, setIdAtributo] = useState('');
    const [idCategoria, setIdCategoria] = useState('');
    const [url, setUrl] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => { cargar(); }, []);

    const cargar = () => {
        setLoading(true);
        Promise.all([
            fetch(`${baseURL}/atributosInfoGet.php`).then(r => r.json()),
            fetch(`${baseURL}/atributosGet.php`).then(r => r.json()),
            fetch(`${baseURL}/categoriasGet.php`).then(r => r.json()),
        ]).then(([infoData, atribData, catData]) => {
            setItems(infoData.atributosInfo || []);
            setConjuntos(atribData.atributos || []);
            setCategorias(catData.categorias || []);
        }).catch(console.error)
        .finally(() => setLoading(false));
    };

    const abrirNuevo = () => {
        setEditando(null); setNombre(''); setIdAtributo(''); setIdCategoria(''); setUrl('');
        setModalOpen(true);
    };

    const abrirEditar = (item) => {
        setEditando(item);
        setNombre(item.nombre || '');
        setIdAtributo(item.idAtributo || '');
        setIdCategoria(item.idCategoria || '');
        setUrl(item.url || '');
        setModalOpen(true);
    };

    // Auto-generate URL from name
    const handleNombre = (v) => {
        setNombre(v);
        setUrl(v.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, ''));
    };

    const guardar = async () => {
        if (!nombre.trim()) { toast.error('El nombre es obligatorio'); return; }
        setGuardando(true);
        const fd = new FormData();
        fd.append('nombre', nombre.trim());
        fd.append('idAtributo', idAtributo);
        fd.append('idCategoria', idCategoria);
        fd.append('url', url);
        if (editando) fd.append('idAtributoInfo', editando.idAtributoInfo);
        const endpoint = editando ? `${baseURL}/atributoInfoUpdate.php` : `${baseURL}/atributoInfoPost.php`;
        try {
            const res = await fetch(endpoint, { method: 'POST', body: fd });
            const d = await res.json();
            if (d.mensaje) { toast.success(editando ? 'Actualizado ✅' : 'Creado ✅'); setModalOpen(false); cargar(); }
            else toast.error(d.error || 'Error');
        } catch { toast.error('Error de conexión'); }
        setGuardando(false);
    };

    const eliminar = (item) => {
        Swal.fire({ title: `¿Eliminar "${item.nombre}"?`, icon: 'warning', showCancelButton: true, confirmButtonColor: '#e53935', confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' })
            .then(async r => {
                if (!r.isConfirmed) return;
                const fd = new FormData();
                fd.append('idAtributoInfo', item.idAtributoInfo);
                const res = await fetch(`${baseURL}/atributoInfoDelete.php`, { method: 'POST', body: fd });
                const d = await res.json();
                if (d.mensaje) { toast.success('Eliminado'); cargar(); }
                else toast.error(d.error || 'Error');
            });
    };

    const getNombreConjunto = (id) => conjuntos.find(c => String(c.idAtributo) === String(id))?.nombre || '—';
    const getNombreCategoria = (id) => categorias.find(c => String(c.idCategoria) === String(id))?.categoria || '—';

    return (
        <div className="atributosInfo">
            <ToastContainer />
            <div className="atribInfoHeader">
                <div>
                    <h2>🔗 Información de Atributos</h2>
                    <p>Asocia atributos a categorías y asigna URLs para cada uno.</p>
                </div>
                <button className="btnNuevoAtribInfo" onClick={abrirNuevo}>+ Nuevo atributo</button>
            </div>

            {loading ? <div className="atribInfoLoading">Cargando...</div> :
                items.length === 0 ? (
                    <div className="atribInfoVacio">
                        <span>🔗</span>
                        <p>No hay atributos de información registrados.</p>
                    </div>
                ) : (
                    <div className="atribInfoTable">
                        <div className="atribInfoTableHead">
                            <span>Nombre</span>
                            <span>Conjunto</span>
                            <span>Categoría</span>
                            <span>URL</span>
                            <span>Acciones</span>
                        </div>
                        {items.map(item => (
                            <div className="atribInfoRow" key={item.idAtributoInfo}>
                                <span className="aiNombre"><strong>{item.nombre}</strong></span>
                                <span className="aiConjunto">
                                    <span className="badge-conjunto">{getNombreConjunto(item.idAtributo)}</span>
                                </span>
                                <span className="aiCategoria">
                                    <span className="badge-categoria">{getNombreCategoria(item.idCategoria)}</span>
                                </span>
                                <span className="aiUrl"><code>{item.url || '—'}</code></span>
                                <div className="aiAcciones">
                                    <button className="btnEditar" onClick={() => abrirEditar(item)}>✏️</button>
                                    <button className="btnEliminar" onClick={() => eliminar(item)}>🗑️</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )
            }

            {modalOpen && (
                <div className="atribInfoOverlay" onClick={() => setModalOpen(false)}>
                    <div className="atribInfoModal" onClick={e => e.stopPropagation()}>
                        <div className="atribInfoModalHeader">
                            <h3>{editando ? 'Editar atributo' : 'Nuevo atributo de información'}</h3>
                            <button onClick={() => setModalOpen(false)}>✕</button>
                        </div>
                        <div className="atribInfoModalBody">
                            <label>Nombre *</label>
                            <input type="text" value={nombre} onChange={e => handleNombre(e.target.value)} placeholder="Ej: Rojo, Talla M, Algodón..." autoFocus />

                            <label>Conjunto de atributos</label>
                            <select value={idAtributo} onChange={e => setIdAtributo(e.target.value)}>
                                <option value="">— Sin conjunto —</option>
                                {conjuntos.map(c => <option key={c.idAtributo} value={c.idAtributo}>{c.nombre}</option>)}
                            </select>

                            <label>Categoría asociada</label>
                            <select value={idCategoria} onChange={e => setIdCategoria(e.target.value)}>
                                <option value="">— Sin categoría —</option>
                                {categorias.map(c => <option key={c.idCategoria} value={c.idCategoria}>{c.categoria}</option>)}
                            </select>

                            <label>URL del atributo</label>
                            <input type="text" value={url} onChange={e => setUrl(e.target.value)} placeholder="url-del-atributo" />
                            <p className="atribInfoHint">Se genera automáticamente desde el nombre, pero puedes editarla.</p>
                        </div>
                        <div className="atribInfoModalFooter">
                            <button className="btnCancelar" onClick={() => setModalOpen(false)}>Cancelar</button>
                            <button className="btnGuardar" onClick={guardar} disabled={guardando}>
                                {guardando ? 'Guardando...' : editando ? 'Actualizar' : 'Crear'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
